import { InfoTip } from "@/design-system/InfoTip/InfoTip";
import { cn } from "@/lib/utils";
import { ComponentProps } from "react";

// min-w-0 and max-w-full let long translated labels truncate inside a grid cell.
export const statBox =
  "flex min-w-0 flex-col items-center justify-center gap-0.5 rounded-xl border border-transparent bg-surface-raised px-2 py-2 text-center";
export const statLabel = "max-w-full truncate text-tiny uppercase opacity-70";

/** A Gallery stat tile that opens an explainer: the whole tile is the InfoTip's trigger. */
export const GalleryStatTip = (
  props: Omit<ComponentProps<typeof InfoTip>, "className">,
) => (
  <InfoTip
    {...props}
    className={cn(statBox, "h-full w-full text-current hover:text-current")}
  />
);
